import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import AuthContext from "../../../../contexts/auth";
import { getClientDomain, getToken, translate } from "../../../../utils/Common";
// components
import ItemMethod from "./ItemMethod";
// icons
import * as BsIcons from "react-icons/bs";
import ignoreAbort from '../../../../utils/ignoreAbort';

const PaymentMethods = ({ addCambio, setAddCambio, montoFacturado, cambio, saldo, methodsChosen, setMethodsChosen }) => {
    const userContext = useContext(AuthContext);
    const [methods, setMethods] = useState([]);
    const [methodSelected, setMethodSelected] = useState(null);
    const { register, reset, handleSubmit } = useForm();

    const [adminMethods, ] = useState([ 2, 3, 4, 6, 8, 9, 10 ]);
    const [counterMethods, ] = useState([ 2, 3, 4, 6, 10 ]);

    const addMethod = (data) => {
        setMethodsChosen([...methodsChosen, { id: Number(data.method), name: methods.filter(m => m.id === Number(data.method))[0].name, amount: Number(data.monto) }]);
        setMethodSelected(null);
        reset();
    }

    const deleteMethod = (id) => {
        setMethodsChosen(methodsChosen.filter((p) => p.id !== id));
    }

    const clearPayment = () => {
        setMethodSelected(null);
        reset();
    }

    useEffect(() => {
        const controller = new AbortController();
        try {
            const getPaymentMethods = async () => {
                const response = await fetch(`${getClientDomain()}/system/paymentMethods`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${getToken()}`
                    }
                });

                const result = await response.json();
                if (result.code === 200) {
                    if (result.payload) setMethods(result.payload);
                    else setMethods([ { id: 0, name: 'No hay métodos disponibles' }]);
                }
                else {
                    setMethods([ { id: 0, name: 'No hay métodos disponibles' }]);
                }
            }

            getPaymentMethods().catch(ignoreAbort);
        } catch (err) {
            console.log(err);
            setMethods([ { id: 0, name: 'No hay métodos disponibles' }]);
        }
        return () => controller.abort();
    }, []);

    return (
        <>
            <div className="flex flex-wrap -mx-2 mt-3 mx-0 mb-1 titlePayments">
                <h6 className="my-1"><BsIcons.BsCashCoin size={18} className="mx-2" />{translate("global.paymentMethod")}</h6> 
            </div>
            
            <form className="flex flex-wrap -mx-2 mx-3 mb-1 pb-2 border-bottom" onSubmit={ handleSubmit(addMethod) }>
                <div className="w-12/12 md:w-4/12 mb-1" >
                    <label className="mb-0 mt-1" htmlFor="selectMethods">{translate("global.selectPaymentMethod")}:</label>
                    <select className="h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed h-9 text-sm text-sm" disabled={ saldo > 0 ? false : true } onChange={ (e) => setMethodSelected(Number(e.target.value)) } id="selectMethods" name="method" ref={register}>
                        <option defaultValue>Seleccionar</option>
                        { methods?.length > 0 && methods.map((method, index) => 
                        ((userContext.user?.IsAdmin && adminMethods.includes(method.id)) || 
                        (!userContext.user?.IsAdmin && counterMethods.includes(method.id))) && 
                        <option type="button" key={index} className="text-sm text-left" value={method.id}>{ `${method.name?.substring(0,1)}${method.name?.toLowerCase().substring(1)}` }</option>) 
                    }
                    </select>
                </div>

                { methodSelected &&
                    <div className="w-12/12 md:w-5/12">
                        <label className="mb-0 mt-1" htmlFor="inputMonto">{translate("global.amount")}:</label>
                        <div className="flex w-full items-stretch">
                            <input type="number" placeholder="0" step="0.01" id="inputMonto" name="monto" className="h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed h-9 text-sm text-sm font-semibold" ref={ register } />
                            <div className="flex items-center">
                                <button type="submit" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/90 text-sm" >{translate("global.add")}</button>
                                <button type="button" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 h-8 rounded-md px-3 text-xs border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground text-sm" onClick={ () => clearPayment() } >{translate("global.clean")}</button>
                            </div>
                        </div>
                    </div>
                }
            </form>

            <div className="flex flex-wrap -mx-2 mx-3">
                { methodsChosen.length > 0 &&
                    methodsChosen.map((method, index) => <ItemMethod paymentMethod={ method } key={index} deleteMethod={ deleteMethod } />)
                }

                { methodsChosen.length > 0 &&
                <>
                    <div className="w-12/12 md:w-12/12 border-bottom flex flex-row pb-2 mt-1" >
                        <div className="packageForPickUp-precioTotal">
                            <label className="mb-0 font-semibold" >{translate("dashboard.packages.pickUp.paymentMethod.amountBilled")}</label>
                            <input type="text" value={ `$ ${montoFacturado}` } readOnly className="h-9 text-sm text-sm w-full border-0 bg-transparent px-0 text-sm text-foreground font-semibold py-0"/>
                        </div>

                        <div className="packageForPickUp-precioTotal">
                            <label className="mb-0 font-semibold" >{translate("dashboard.packages.pickUp.paymentMethod.outstandingBalance" )}</label>
                            <input type="text" value={ `$ ${saldo}` } readOnly className="h-9 text-sm text-sm w-full border-0 bg-transparent px-0 text-sm text-foreground font-semibold py-0"/>
                        </div>

                        <div className="packageForPickUp-precioTotal">
                            <label className="mb-0 font-semibold" >{translate("dashboard.packages.pickUp.paymentMethod.change" )}</label>
                            <input type="text" value={ `$ ${cambio}` } readOnly className="h-9 text-sm text-sm w-full border-0 bg-transparent px-0 text-sm text-foreground font-semibold py-0"/>
                        </div>
                    </div>

                    { (userContext?.user.IsAdmin || userContext?.user.IdPlataforma === 2) && cambio > 0 &&
                        <div className="w-12/12 md:w-12/12 border-bottom pb-2 mt-1">
                            <div className="flex items-center gap-2">
                                <input type="checkbox" className="size-4 cursor-pointer accent-primary" id="switchAddAbono" checked={ addCambio } onChange={ (e) => setAddCambio(e.target.checked) } />
                                <label className="cursor-pointer text-sm text-foreground" htmlFor="switchAddAbono" >
                                    <div className="mt-1">{translate("global.question.payChange")}</div>
                                </label>
                            </div>
                        </div>
                    }
                </>
                }

            </div>
        </>
    );
}

export default PaymentMethods;